import {Component} from '@angular/core';
import {EsignResponse} from '@npck/auth-frontend-api';
import {RouterService} from '@npck/libs/commons';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {ESignDialogService} from '../../domain/e-sign-dialog.service';
import {Path} from '../../path';

@Component({
    templateUrl: 'reset-esign.component.html',
    styleUrls: ['reset-esign.component.scss'],
    standalone: false,
})
export class ResetEsignComponent {

    currentEsign: EsignResponse;

    constructor(
        private eSignDialogService: ESignDialogService,
        public oauthHolderService: AuthHolderService,
        private routerService: RouterService,
    ) {
        this.showReissueDialog();
    }

    showReissueDialog(): void {
        this.currentEsign = this.oauthHolderService.authSessionData.esign as EsignResponse;
        this.eSignDialogService.openDialog({
            esign: this.currentEsign,
            hasOrgSignScope: !!this.currentEsign.bin,
            target: 'reissue',
        }).subscribe(() => {
            this.routerService.navigate(Path.OAUTH_CONSENT);
        });
    }
}
